<ul>
	<li class="obg-m-oms-summary-list-heading">
		<h1 class="obg-m-oms-summary-list-heading-title">{{ "oms.list-heading" | translate }}</h1>
		<span class="ico-mail"></span>
	</li>
	<li class="obg-m-oms-summary-list-spinner" *ngIf="busy && !messages?.length; else messagesContent">
		<mat-spinner diameter="40"></mat-spinner>
	</li>
	<ng-template #messagesContent>
		<li
			class="obg-m-oms-summary-list-item"
			[ngClass]="message.isRead ? 'read' : 'unread'"
			*ngFor="let message of messages; trackBy: trackByMessage"
			(click)="show.emit(message.id)"
		>
			<img
				class="obg-m-oms-summary-list-item-avatar"
				[src]="message.content?.image.url"
				[alt]="message.content?.image.alt"
			/>
			<div>
				<p class="obg-m-oms-summary-list-item-title" [ngClass]="{ unread: !message.isRead }">
					{{ message.content?.title | truncate: 60 : "…" }}
				</p>
				<p class="obg-m-oms-summary-list-item-sub-headline" *ngIf="message.content?.subHeadline">
					{{ message.content.subHeadline }}
				</p>
				<p
					class="obg-m-oms-summary-list-item-body"
					[innerHtml]="message.content?.body | obgOmsSummaryLocalizeTime | truncate: 120 : '…'"
				></p>
				<div class="obg-m-oms-summary-list-item-footer">
					<p class="obg-m-oms-summary-list-item-received" *ngIf="message.sendDate">
						{{ "oms.received-on" | translate }}: {{ message.sendDate | date: "longDate" }}
					</p>
					<a class="obg-m-oms-summary-list-item-expand" [ngClass]="{ unread: !message.isRead }">{{
						"general.read-more" | translate
					}}</a>
				</div>
			</div>
		</li>
		<li
			class="obg-m-oms-summary-list-no-items obg-m-oms-summary-list-item-centered"
			*ngIf="!(messages?.length > 0)"
		>
			{{ "oms.no-messages" | translate }}
		</li>
	</ng-template>
	<li class="obg-m-oms-summary-list-centre-link obg-m-oms-summary-list-item-centered" (click)="show.emit()">
		{{ "oms.go-to-message-center" | translate }}
		<span class="ico-arrow-down"></span>
	</li>
</ul>
